import React, { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import heroImg from "../assets/image.png";
import "./AreaPage.css";
import   ServiceShowcase from"../components/ServiceShowcase.jsx"

const AreaPage = () => {
  const { pathname } = useLocation();

  const getArea = () => {
    return pathname
      .replace("/mobile-repair-service-in-", "")
      .replace("/mobile-repair-service-in/", "")
      .split("/")[0];
  };





const AREA_SEO_CONTENT = {

  koramangala: {
    title: "Mobile Repair Service in Koramangala Bangalore",
    description: "Get fast and reliable mobile repair service in Koramangala, Bangalore. Servizy offers screen replacement, battery change, software repair, and doorstep mobile service.",
    keywords: "mobile repair service in Koramangala, phone repair Koramangala, mobile service Bangalore, doorstep mobile repair",
    canonical: "https://servizy.co.in/mobile-repair-service-in-koramangala",
    robots: "index, follow"
  },

  hsrlayout: {
    title: "Mobile Repair Service in HSR Layout Bangalore",
    description: "Professional mobile repair service in HSR Layout, Bangalore with expert technicians for screen repair, battery replacement, charging issues, and software support.",
    keywords: "mobile repair HSR Layout, phone repair HSR Layout, mobile service Bangalore, smartphone repair",
    canonical: "https://servizy.co.in/mobile-repair-service-in-hsr-layout",
    robots: "index, follow"
  },

  electroniccity: {
    title: "Mobile Repair Service in Electronic City Bangalore",
    description: "Trusted mobile repair service in Electronic City, Bangalore. We repair all smartphone brands with quick pickup, doorstep support, and affordable pricing.",
    keywords: "mobile repair Electronic City, phone repair Bangalore, smartphone repair service, mobile fixing",
    canonical: "https://servizy.co.in/mobile-repair-service-in-electronic-city",
    robots: "index, follow"
  },

  whitefield: {
    title: "Mobile Repair Service in Whitefield Bangalore",
    description: "Looking for mobile repair in Whitefield? Servizy provides expert mobile repair services including display replacement, battery repair, and water damage fixing.",
    keywords: "mobile repair Whitefield, phone repair Whitefield, mobile service center Bangalore, smartphone repair",
    canonical: "https://servizy.co.in/mobile-repair-service-in-whitefield",
    robots: "index, follow"
  },

  mahadevapura: {
    title: "Mobile Repair Service in Mahadevapura Bangalore",
    description: "Servizy offers reliable mobile repair service in Mahadevapura, Bangalore for all major smartphone brands with quick turnaround and doorstep support.",
    keywords: "mobile repair Mahadevapura, phone repair Bangalore, mobile screen repair, smartphone service",
    canonical: "https://servizy.co.in/mobile-repair-service-in-mahadevapura",
    robots: "index, follow"
  },

  jayanagar: {
    title: "Mobile Repair Service in Jayanagar Bangalore",
    description: "Affordable mobile repair service in Jayanagar, Bangalore for screen damage, battery replacement, charging issues, and software troubleshooting.",
    keywords: "mobile repair Jayanagar, phone repair Jayanagar, mobile service Bangalore, doorstep repair, mobile repair near me",
    canonical: "https://servizy.co.in/mobile-repair-service-in-jayanagar",
    robots: "index, follow"
  },

  rajajinagar: {
    title: "Mobile Repair Service in Rajajinagar Bangalore",
    description: "Expert mobile repair service in Rajajinagar, Bangalore. Servizy repairs all phone brands with genuine spare parts and skilled technicians.",
    keywords: "mobile repair Rajajinagar, smartphone repair Bangalore, phone repair service, mobile fixing",
    canonical: "https://servizy.co.in/mobile-repair-service-in-rajajinagar",
    robots: "index, follow"
  },

  malleswaram: {
    title: "Mobile Repair Service in Malleswaram Bangalore",
    description: "Get professional mobile repair service in Malleswaram, Bangalore with quick repair solutions for broken screens, battery issues, and software problems.",
    keywords: "mobile repair Malleswaram, phone service Bangalore, smartphone repair, mobile repair near me",
    canonical: "https://servizy.co.in/mobile-repair-service-in-malleswaram",
    robots: "index, follow"
  },

  marathahalli: {
    title: "Mobile Repair Service in Marathahalli Bangalore",
    description: "Servizy provides trusted mobile repair service in Marathahalli, Bangalore with doorstep support for all major smartphone brands.",
    keywords: "mobile repair Marathahalli, phone repair Bangalore, smartphone service, mobile screen repair",
    canonical: "https://servizy.co.in/mobile-repair-service-in-marathahalli",
    robots: "index, follow"
  },

  jpnagar: {
    title: "Mobile Repair Service in JP Nagar Bangalore",
    description: "Fast and affordable mobile repair service in JP Nagar, Bangalore. We repair display, battery, charging port, and software issues.",
    keywords: "mobile repair JP Nagar, phone repair JP Nagar, mobile repair Bangalore, smartphone repair",
    canonical: "https://servizy.co.in/mobile-repair-service-in-jp-nagar",
    robots: "index, follow"
  },

  banashankari: {
    title: "Mobile Repair Service in Banashankari Bangalore",
    description: "Servizy offers professional mobile repair service in Banashankari, Bangalore for all smartphone brands with quality repairs and quick service.",
    keywords: "mobile repair Banashankari, phone repair Bangalore, smartphone repair service, mobile fixing",
    canonical: "https://servizy.co.in/mobile-repair-service-in-banashankari",
    robots: "index, follow"
  },

  krpuram: {
    title: "Mobile Repair Service in KR Puram Bangalore",
    description: "Reliable mobile repair service in KR Puram, Bangalore for screen replacement, battery repair, and software troubleshooting at affordable prices.",
    keywords: "mobile repair KR Puram, phone repair Bangalore, mobile service center, smartphone repair",
    canonical: "https://servizy.co.in/mobile-repair-service-in-kr-puram",
    robots: "index, follow"
  },

  vijayanagar: {
    title: "Mobile Repair Service in Vijayanagar Bangalore",
    description: "Trusted mobile repair service in Vijayanagar, Bangalore with experienced technicians for all smartphone repair needs.",
    keywords: "mobile repair Vijayanagar, phone repair Bangalore, smartphone service, doorstep mobile repair",
    canonical: "https://servizy.co.in/mobile-repair-service-in-vijayanagar",
    robots: "index, follow"
  },

  rajarajeshwarinagar: {
    title: "Mobile Repair Service in RR Nagar Bangalore",
    description: "Get expert mobile repair service in Rajarajeshwari Nagar, Bangalore with quick and affordable repair solutions for all mobile brands.",
    keywords: "mobile repair RR Nagar, phone repair Bangalore, mobile fixing service, smartphone repair",
    canonical: "https://servizy.co.in/mobile-repair-service-in-rajarajeshwari-nagar",
    robots: "index, follow"
  },

  btmlayout: {
    title: "Mobile Repair Service in BTM Layout Bangalore",
    description: "Professional mobile repair service in BTM Layout, Bangalore for screen replacement, battery change, and software repairs.",
    keywords: "mobile repair BTM Layout, phone repair Bangalore, smartphone repair service, mobile repair near me",
    canonical: "https://servizy.co.in/mobile-repair-service-in-btm-layout",
    robots: "index, follow"
  },

  bommanahalli: {
    title: "Mobile Repair Service in Bommanahalli Bangalore",
    description: "Servizy provides reliable mobile repair service in Bommanahalli, Bangalore with quick doorstep repair and expert support.",
    keywords: "mobile repair Bommanahalli, phone repair Bangalore, smartphone service, mobile fixing",
    canonical: "https://servizy.co.in/mobile-repair-service-in-bommanahalli",
    robots: "index, follow"
  },

  domlur: {
    title: "Mobile Repair Service in Domlur Bangalore",
    description: "Affordable and fast mobile repair service in Domlur, Bangalore for all smartphone brands with genuine spare parts.",
    keywords: "mobile repair Domlur, phone repair Bangalore, mobile screen replacement, smartphone repair",
    canonical: "https://servizy.co.in/mobile-repair-service-in-domlur",
    robots: "index, follow"
  },
  rtnagar: {
  title: "Mobile Repair Service in RT Nagar Bangalore",
  description: "Expert mobile repair service in RT Nagar, Bangalore with quick repair support for all mobile phones including screen replacement, battery issues, and software repair.",
  keywords: "mobile repair RT Nagar, phone repair Bangalore, mobile fixing service, smartphone repair",
  canonical: "https://servizy.co.in/mobile-repair-service-in-rt-nagar",
  robots: "index, follow"
},

ulsoor: {
  title: "Mobile Repair Service in Ulsoor Bangalore",
  description: "Professional mobile repair service in Ulsoor, Bangalore with affordable pricing and skilled technicians for all phone brands.",
  keywords: "mobile repair Ulsoor, phone repair Bangalore, mobile service center, smartphone repair",
  canonical: "https://servizy.co.in/mobile-repair-service-in-ulsoor",
  robots: "index, follow"
},

seshadripuram: {
  title: "Mobile Repair Service in Seshadripuram Bangalore",
  description: "Trusted mobile repair service in Seshadripuram, Bangalore for screen repair, battery replacement, and software support.",
  keywords: "mobile repair Seshadripuram, phone repair Bangalore, smartphone repair service, mobile fixing",
  canonical: "https://servizy.co.in/mobile-repair-service-in-seshadripuram",
  robots: "index, follow"
},

kalyannagar: {
  title: "Mobile Repair Service in Kalyan Nagar Bangalore",
  description: "Fast and affordable mobile repair service in Kalyan Nagar, Bangalore with doorstep support for all smartphone brands.",
  keywords: "mobile repair Kalyan Nagar, phone repair Bangalore, smartphone repair, mobile service",
  canonical: "https://servizy.co.in/mobile-repair-service-in-kalyan-nagar",
  robots: "index, follow"
},

kundalahalli: {
  title: "Mobile Repair Service in Kundalahalli Bangalore",
  description: "Get trusted mobile repair service in Kundalahalli, Bangalore for battery replacement, screen repair, and software issues.",
  keywords: "mobile repair Kundalahalli, smartphone repair Bangalore, phone service, mobile repair",
  canonical: "https://servizy.co.in/mobile-repair-service-in-kundalahalli",
  robots: "index, follow"
},
richmondtown: {
  title: "Mobile Repair Service in Richmond Town Bangalore",
  description: "Trusted mobile repair service in Richmond Town, Bangalore with quick doorstep repair for all smartphone brands.",
  keywords: "mobile repair Richmond Town, phone repair Bangalore, smartphone service, mobile fixing",
  canonical: "https://servizy.co.in/mobile-repair-service-in-richmond-town",
  robots: "index, follow"
},

yeshwanthpur: {
  title: "Mobile Repair Service in Yeshwanthpur Bangalore",
  description: "Affordable mobile repair service in Yeshwanthpur, Bangalore for screen repair, battery replacement, and software troubleshooting.",
  keywords: "mobile repair Yeshwanthpur, phone repair Bangalore, smartphone repair, mobile repair service",
  canonical: "https://servizy.co.in/mobile-repair-service-in-yeshwanthpur",
  robots: "index, follow"
},

nagawara: {
  title: "Mobile Repair Service in Nagawara Bangalore",
  description: "Servizy offers professional mobile repair service in Nagawara, Bangalore with quality repairs and quick support.",
  keywords: "mobile repair Nagawara, phone repair Bangalore, smartphone repair service, mobile fixing",
  canonical: "https://servizy.co.in/mobile-repair-service-in-nagawara",
  robots: "index, follow"
},

kalyannagar: {
  title: "Mobile Repair Service in Kalyan Nagar Bangalore",
  description: "Fast and affordable mobile repair service in Kalyan Nagar, Bangalore with doorstep support for all smartphone brands.",
  keywords: "mobile repair Kalyan Nagar, phone repair Bangalore, smartphone repair, mobile service",
  canonical: "https://servizy.co.in/mobile-repair-service-in-kalyan-nagar",
  robots: "index, follow"
},

ulsoor: {
  title: "Mobile Repair Service in Ulsoor Bangalore",
  description: "Professional mobile repair service in Ulsoor, Bangalore with affordable pricing and skilled technicians for all phone brands.",
  keywords: "mobile repair Ulsoor, phone repair Bangalore, mobile service center, smartphone repair",
  canonical: "https://servizy.co.in/mobile-repair-service-in-ulsoor",
  robots: "index, follow"
},

seshadripuram: {
  title: "Mobile Repair Service in Seshadripuram Bangalore",
  description: "Trusted mobile repair service in Seshadripuram, Bangalore for screen repair, battery replacement, and software support.",
  keywords: "mobile repair Seshadripuram, phone repair Bangalore, smartphone repair service, mobile fixing",
  canonical: "https://servizy.co.in/mobile-repair-service-in-seshadripuram",
  robots: "index, follow"
},
bagalur: {
  title: "Mobile Repair Service in Bagalur Bangalore",
  description: "Fast and reliable mobile repair service in Bagalur, Bangalore for all smartphone repair and replacement needs.",
  keywords: "mobile repair Bagalur, phone repair Bangalore, mobile screen replacement, smartphone repair",
  canonical: "https://servizy.co.in/mobile-repair-service-in-bagalur",
  robots: "index, follow"
},

indiranagar: {
  title: "Mobile Repair Service in Indiranagar Bangalore",
  description: "Get expert mobile repair service in Indiranagar, Bangalore with doorstep support for screen, battery, and software repairs.",
  keywords: "mobile repair Indiranagar, phone repair Bangalore, smartphone service, mobile fixing",
  canonical: "https://servizy.co.in/mobile-repair-service-in-indiranagar",
  robots: "index, follow"
},

bellandur: {
  title: "Mobile Repair Service in Bellandur Bangalore",
  description: "Professional mobile repair service in Bellandur, Bangalore with affordable pricing and experienced mobile technicians.",
  keywords: "mobile repair Bellandur, phone repair Bangalore, smartphone repair service, mobile fixing",
  canonical: "https://servizy.co.in/mobile-repair-service-in-bellandur",
  robots: "index, follow"
},

hebbagodi: {
  title: "Mobile Repair Service in Hebbagodi Bangalore",
  description: "Trusted mobile repair service in Hebbagodi, Bangalore for all mobile brands with quick repair and doorstep service support.",
  keywords: "mobile repair Hebbagodi, phone repair Bangalore, smartphone repair, mobile service center",
  canonical: "https://servizy.co.in/mobile-repair-service-in-hebbagodi",
  robots: "index, follow"
}


};
const area = getArea();

const seoKey = area
  .replace(/-/g, "")
  .toLowerCase();

const seoData = AREA_SEO_CONTENT[seoKey];

  const areaName = area
    ? area.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
    : "Whitefield";
  const pageTitle =
    seoData?.title || `Mobile Repair Service in ${areaName} Bangalore | Servizy`;
  const pageDescription =
  seoData?.description;
  const pageKeywords =
    seoData?.keywords ||
    `mobile repair service in ${areaName}, phone repair ${areaName}, doorstep mobile repair Bangalore`;
  const pageCanonical =
    seoData?.canonical ||
    `https://servizy.co.in/mobile-repair-service-in-${area.toLowerCase()}`;
  const pageRobots = seoData?.robots || "index, follow";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
<Helmet>

  <title>{pageTitle}</title>

  <meta
    key="description"
    name="description"
    content={pageDescription}
  />

  <meta
    key="keywords"
    name="keywords"
    content={pageKeywords}
  />

  <link
    rel="canonical"
    href={pageCanonical}
  />

  <meta
    name="robots"
    content={pageRobots}
  />

</Helmet>
      <main className="area-page">

        {/* HERO */}
        <section
          className="hsr-hero"
          style={{ backgroundImage: `url(${heroImg})` }}
        >
          <div className="hsr-content fade-up">
            <h1>
              Mobile Repair Service in{" "}
              <span className="area-name">{areaName}</span>
            </h1>

            <p>Fast, Reliable & Affordable Doorstep Repair</p>

            <Link to="/login" className="cta-btn">
              Book Repair
            </Link>
          </div>
        </section>

      <section className="area-new fade-up">
  <div className="container">

   <h2 className="main-title">
  {seoData?.title}
</h2>
<p className="intro">
  {seoData?.description}
</p>

    {/* WHY */}
    <div className="why-box fade-up">
      <h3>Why Choose Our Mobile Repair Service in {areaName}?</h3>

      <div className="why-grid">
        <span>✔️ Certified & experienced technicians</span>
        <span>✔️ Doorstep mobile repair service</span>
        <span>✔️ Same-day service for most issues</span>
        <span>✔️ Affordable pricing with no hidden charges</span>
        <span>✔️ Use of high-quality spare parts</span>
        <span>✔️ Service available across all areas of {areaName}</span>
      </div>

      <p style={{ marginTop: "15px" }}>
        Our goal is to deliver a hassle-free repair experience with long-lasting results.
      </p>
    </div>

    {/* SERVICES */}
<div className="services-section">
  <h3 className="services-title">Our Mobile Repair Services</h3>

  <div className="services-grid">

    <div className="service-card">
      <div className="service-header">
        <span className="icon">📱</span>
        <h4>Screen Replacement</h4>
      </div>
      <p>
        Broken or cracked screen? We provide high-quality screen replacement with precision and care.
      </p>
    </div>

    <div className="service-card">
      <div className="service-header">
        <span className="icon">🔋</span>
        <h4>Battery Replacement</h4>
      </div>
      <p>
        Battery draining fast? We replace it with a durable and genuine battery to restore performance.
      </p>
    </div>

    <div className="service-card">
      <div className="service-header">
        <span className="icon">🔌</span>
        <h4>Charging Port Repair</h4>
      </div>
      <p>
        Facing charging issues? Our technicians can fix or replace faulty charging ports quickly.
      </p>
    </div>

    <div className="service-card">
      <div className="service-header">
        <span className="icon">💧</span>
        <h4>Water Damage Repair</h4>
      </div>
      <p>
        Dropped your phone in water? We offer advanced diagnostics and recovery solutions.
      </p>
    </div>

    <div className="service-card">
      <div className="service-header">
        <span className="icon">⚙️</span>
        <h4>Software & OS Issues</h4>
      </div>
      <p>
        From app crashes to system errors, we resolve all software-related problems efficiently.
      </p>
    </div>

    <div className="service-card">
      <div className="service-header">
        <span className="icon">🔊</span>
        <h4>Speaker & Mic Repair</h4>
      </div>
      <p>
        Experiencing audio issues? We repair or replace speakers and microphones for clear sound.
      </p>
    </div>

  </div>
</div>

    {/* EXTRA CONTENT */}
   <div className="details-section">

  {/* DOORSTEP */}
  <div className="detail-card">
    <h3>🚀 Doorstep Mobile Repair in {areaName}</h3>
    <p>
      Skip the hassle of visiting a service center. Book our doorstep mobile repair service and get your phone fixed at your home or office. Our technician will arrive on time, diagnose the issue, and fix it on the spot.
    </p>
  </div>

  {/* PRICING */}
  <div className="detail-card">
    <h3>💰 Affordable Mobile Repair with Warranty</h3>
    <p>
      We offer competitive pricing without compromising on quality. All repairs come with a service warranty, ensuring complete peace of mind.
    </p>
  </div>

  {/* PROCESS */}
  <div className="detail-card">
    <h3>⚙️ How It Works</h3>
    <ul className="steps">
      <li>Book your service online or call us</li>
      <li>Choose your preferred time slot</li>
      <li>Technician visits your location</li>
      <li>Get your phone repaired instantly</li>
    </ul>
  </div>

  {/* FAQ */}
  <div className="detail-card">
    <h3>❓ FAQ – Mobile Repair Service in {areaName}</h3>

    <div className="faq-item">
      <strong>1. How long does mobile repair take?</strong>
      <p>Most repairs are completed within 30–60 minutes.</p>
    </div>

    <div className="faq-item">
      <strong>2. Do you provide doorstep service?</strong>
      <p>Yes, we offer doorstep service across all areas.</p>
    </div>

    <div className="faq-item">
      <strong>3. Is there any warranty?</strong>
      <p>Yes, we provide limited warranty.</p>
    </div>

    <div className="faq-item">
      <strong>4. What brands do you repair?</strong>
      <p>iPhone, Samsung, OnePlus, Xiaomi, Vivo, Oppo & more.</p>
    </div>

    <div className="faq-item">
      <strong>5. How much does mobile repair cost?</strong>
      <p>Depends on issue & model. Transparent pricing guaranteed.</p>
    </div>
  </div>

</div>

    {/* CTA */}
    <div className="cta-new fade-up">
      <h3>Get your smartphone fixed today with the best mobile repair service in {areaName}</h3>
      <p>📞 Book now with Servizy for fast, reliable, and affordable repairs!</p>
      <br/>
      <Link to="/login" className="cta-btn">Book Now</Link>
    </div>

  </div>
</section>
        <ServiceShowcase />

      </main>
    </>
  );
};

export default AreaPage;
